import _error from './_error.js';
import ArrowClockwiseFill from './arrow-clockwise-fill.js';
import ArrowCounterClockwiseFill from './arrow-counter-clockwise-fill.js';
import ArrowDown from './arrow-down.js';
import ArrowLeft from './arrow-left.js';
import ArrowRight from './arrow-right.js';
import ArrowSquareOut from './arrow-square-out.js';
import ArrowUp from './arrow-up.js';
import ArrowsClockwiseFill from './arrows-clockwise-fill.js';
import ArrowsCounterClockwiseFill from './arrows-counter-clockwise-fill.js';
import ArrowsDownUp from './arrows-down-up.js';
import ArrowsInSimple from './arrows-in-simple.js';
import ArrowsLeftRight from './arrows-left-right.js';
import ArrowsOutSimple from './arrows-out-simple.js';
import BellFill from './bell-fill.js';
import BookmarkSimpleFill from './bookmark-simple-fill.js';
import BookmarkSimple from './bookmark-simple.js';
import CalendarBlank from './calendar-blank.js';
import CaretCircleDownFill from './caret-circle-down-fill.js';
import CaretCircleDown from './caret-circle-down.js';
import CaretCircleUpFill from './caret-circle-up-fill.js';
import CaretCircleUp from './caret-circle-up.js';
import CaretDownFill from './caret-down-fill.js';
import CaretDown from './caret-down.js';
import CaretLeft from './caret-left.js';
import CaretRight from './caret-right.js';
import CaretUpDownFill from './caret-up-down-fill.js';
import CaretUpFill from './caret-up-fill.js';
import CaretUp from './caret-up.js';
import ChatsFill from './chats-fill.js';
import CheckCircleFill from './check-circle-fill.js';
import CheckCircle from './check-circle.js';
import CheckSquare from './check-square.js';
import Check from './check.js';
import DotsThreeOutlineFill from './dots-three-outline-fill.js';
import DownloadSimple from './download-simple.js';
import EnvelopeSimple from './envelope-simple.js';
import EyeFill from './eye-fill.js';
import EyeSlashFill from './eye-slash-fill.js';
import Files from './files.js';
import FloppyDiskFill from './floppy-disk-fill.js';
import FolderFill from './folder-fill.js';
import Folder from './folder.js';
import FunnelSimple from './funnel-simple.js';
import GearSixFill from './gear-six-fill.js';
import Globe from './globe.js';
import HouseFill from './house-fill.js';
import InfoFill from './info-fill.js';
import Info from './info.js';
import Link from './link.js';
import List from './list.js';
import LockKeyFill from './lock-key-fill.js';
import LockKeyOpenFill from './lock-key-open-fill.js';
import LogoAndroidFill from './logo-android-fill.js';
import LogoAndroid from './logo-android.js';
import LogoAppleFill from './logo-apple-fill.js';
import LogoApple from './logo-apple.js';
import LogoAppleMacCommand from './logo-apple-mac-command.js';
import LogoFacebookFill from './logo-facebook-fill.js';
import Facebook from './logo-facebook-fill.js'; // Deprecated Name; remove in V2
import LogoFigma from './logo-figma.js';
import LogoGithubFill from './logo-github-fill.js';
import LogoInstagram from './logo-instagram.js'; // Deprecated Name; remove in V2
import Instagram from './instagram_DEPRECATED.js'; // Deprecated Name; remove in V2
import LogoKalturaPlay from './logo-kaltura-play.js';
import LogoLinkedinFill from './logo-linkedin-fill.js';
import Linkedin from './logo-linkedin-fill.js'; // Deprecated Name; remove in V2
import LogoMicrosoftExcelFill from './logo-microsoft-excel-fill.js';
import LogoMicrosoftOutlookFill from './logo-microsoft-outlook-fill.js';
import LogoMicrosoftTeamsFill from './logo-microsoft-teams-fill.js';
import LogoMicrosoftWindowsFill from './logo-microsoft-windows-fill.js';
import LogoMicrosoftWordFill from './logo-microsoft-word-fill.js';
import LogoPinterestFill from './logo-pinterest-fill.js';
import LogoRedditFill from './logo-reddit-fill.js';
import LogoReddit from './logo-reddit.js';
import LogoSlack from './logo-slack.js';
import LogoSnapchat from './logo-snapchat.js';
import LogoSoundcloudFill from './logo-soundcloud-fill.js';
import LogoTiktokFill from './logo-tiktok-fill.js';
import LogoTwitterFill from './logo-twitter-fill_DEPRECATED.js'; // Deprecated Brand Mark; Remove in V2
import Twitter from './twitter_DEPRECATED.js'; // Deprecated Brand Mark; Remove in V2
import LogoX from './logo-x.js'; // Replace with phosphor icon version when available
import LogoYoutubeFill from './logo-youtube-fill.js';
import Youtube from './youtube_DEPRECATED.js'; // Deprecated Brand Mark; Remove in V2
import MagnifyingGlass from './magnifying-glass.js';
import MinusCircleFill from './minus-circle-fill.js';
import MinusCircle from './minus-circle.js';
import Paperclip from './paperclip.js';
import PauseCircleFill from './pause-circle-fill.js';
import PauseCircle from './pause-circle.js';
import PauseFill from './pause-fill.js';
import PencilSimpleLineFill from './pencil-simple-line-fill.js';
import PhoneFill from './phone-fill.js';
import PlayCircleFill from './play-circle-fill.js';
import PlayCircle from './play-circle.js';
import PlayFill from './play-fill.js';
import PlusCircleFill from './plus-circle-fill.js';
import PlusCircle from './plus-circle.js';
import Plus from './plus.js';
import Prohibit from './prohibit.js';
import QuestionFill from './question-fill.js';
import Question from './question.js';
import QuotesFill from './quotes-fill.js';
import RadioButtonFill from './radio-button-fill.js';
import SignIn from './sign-in.js';
import SignOut from './sign-out.js';
import SpeakerSimpleHighFill from './speaker-simple-high-fill.js';
import SpeakerSimpleNoneFill from './speaker-simple-none-fill.js';
import SpeakerSimpleSlashFill from './speaker-simple-slash-fill.js';
import StarFill from './star-fill.js';
import Star from './star.js';
import TrashSimpleFill from './trash-simple-fill.js';
import UploadSimple from './upload-simple.js';
import UserCircleFill from './user-circle-fill.js';
import UserFill from './user-fill.js';
import WarningCircleFill from './warning-circle-fill.js';
import WarningCircle from './warning-circle.js';
import WarningFill from './warning-fill.js';
import Warning from './warning.js';
import XCircleFill from './x-circle-fill.js';
import XCircle from './x-circle.js';
import X from './x.js';

export default {
  _error,
  ArrowClockwiseFill,
  ArrowCounterClockwiseFill,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowSquareOut,
  ArrowUp,
  ArrowsClockwiseFill,
  ArrowsCounterClockwiseFill,
  ArrowsDownUp,
  ArrowsInSimple,
  ArrowsLeftRight,
  ArrowsOutSimple,
  BellFill,
  BookmarkSimpleFill,
  BookmarkSimple,
  CalendarBlank,
  CaretCircleDownFill,
  CaretCircleDown,
  CaretCircleUpFill,
  CaretCircleUp,
  CaretDownFill,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUpDownFill,
  CaretUpFill,
  CaretUp,
  ChatsFill,
  CheckCircleFill,
  CheckCircle,
  CheckSquare,
  Check,
  DotsThreeOutlineFill,
  DownloadSimple,
  EnvelopeSimple,
  EyeFill,
  EyeSlashFill,
  Files,
  FloppyDiskFill,
  FolderFill,
  Folder,
  FunnelSimple,
  GearSixFill,
  Globe,
  HouseFill,
  InfoFill,
  Info,
  Link,
  List,
  LockKeyFill,
  LockKeyOpenFill,
  LogoAndroidFill,
  LogoAndroid,
  LogoAppleFill,
  LogoApple,
  LogoAppleMacCommand,
  LogoFacebookFill,
  Facebook, // DEPRECATED
  LogoFigma,
  LogoGithubFill,
  LogoInstagram,
  Instagram, // DEPRECATED
  LogoKalturaPlay,
  LogoLinkedinFill,
  Linkedin, // DEPRECATED
  LogoMicrosoftExcelFill,
  LogoMicrosoftOutlookFill,
  LogoMicrosoftTeamsFill,
  LogoMicrosoftWindowsFill,
  LogoMicrosoftWordFill,
  LogoPinterestFill,
  LogoRedditFill,
  LogoReddit,
  LogoSlack,
  LogoSnapchat,
  LogoSoundcloudFill,
  LogoTiktokFill,
  LogoTwitterFill, // DEPRECATED
  Twitter, // DEPRECATED
  LogoX,
  LogoYoutubeFill,
  Youtube, // DEPRECATED
  MagnifyingGlass,
  MinusCircleFill,
  MinusCircle,
  Paperclip,
  PauseCircleFill,
  PauseCircle,
  PauseFill,
  PencilSimpleLineFill,
  PhoneFill,
  PlayCircleFill,
  PlayCircle,
  PlayFill,
  PlusCircleFill,
  PlusCircle,
  Plus,
  Prohibit,
  QuestionFill,
  Question,
  QuotesFill,
  RadioButtonFill,
  SignIn,
  SignOut,
  SpeakerSimpleHighFill,
  SpeakerSimpleNoneFill,
  SpeakerSimpleSlashFill,
  StarFill,
  Star,
  TrashSimpleFill,
  UploadSimple,
  UserCircleFill,
  UserFill,
  WarningCircleFill,
  WarningCircle,
  WarningFill,
  Warning,
  XCircleFill,
  XCircle,
  X,
};
